exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-data-table__wrapper table {\n  min-height: 300px;\n}\n.v-data-table__wrapper table tbody tr, .v-data-table__wrapper table tbody td {\n    height: 50px !important;\n    max-height: 50px !important;\n}\n.v-data-table__wrapper table tbody tr td, .v-data-table__wrapper table tbody td td {\n      overflow: hidden;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-30dee4b6","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/elements/TableCard.vue
// module id = 561
// module chunks = 0